// extracted by mini-css-extract-plugin
export default {"root":"NavItemBadge_root__lyHCM","mobile":"NavItemBadge_mobile__xpvcz"};